import React from "react";
import ServicesAreaItem from "./ServicesAreaItem";

const ServicesArea = () => {
  const services_area_list = [
    {
      title: "Logo Design",
      desc: "Craft seamless experiences with our graphic design agency to create intuitive designs and enhance user engagement.",
      url: "/services/logo-design",
      delay_time: 2,
      img: "/img/my-img/logo-design-australia.webp",
      alt: "Logo Design Australia"
    },
    {
      title: "Brand Design",
      desc: "Stop searching for graphic designers near me and select a complete graphic design agency like Innovatix Hub Australia.",
      url: "/services",
      delay_time: 4,
      img: "/img/my-img/brand-design-au.webp",
      alt: "Logo Design Australia"
    },
    {
      title: "Website Design",
      desc: "With our not-limited graphic design agency, we create visually appealing, user-friendly websites that drive engagement and conversions.",
      url: "/services/web-design",
      delay_time: 6,
      img: "/img/my-img/website-design-au.webp",
      alt: "Logo Design Australia"
    },
    {
      title: "Package Design",
      desc: "Innovatix Design Agency Australia is perfect to market your product through attractive packaging locality and globally.",
      url: "/services/package-design",
      delay_time: 8,
      img: "/img/custom-service/4.webp",
      alt: "Logo Design Australia"
    },
  ];

  return (
    <section className="services-area pt-35 pb-95">
      <div className="container">
        <div className="section-title text-center mb-60">
          <h3 className="sub-title">Our Services</h3>
          <h2 className="title">Our Graphic Design<br /> Services in Australia</h2>
          <p style={{margin: "12px 0px 12px 0px"}}>Innovatix Hub, AU provides services designed to elevate businesses by providing a complete one-stop solution.</p>
        </div>
        <div className="row justify-content-center">
          {services_area_list.map((item, index) => (
            <div key={index} className="col-xl-3 col-lg-4 col-md-6 col-sm-10">
              <ServicesAreaItem index={index} item={item} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesArea;
